module.exports = __webpack_public_path__ + "img/icon_connexion_.d54b04d8.png";